import ProfileIcon from 'assets/images/svg/userCenter/profile.svg'
import WalletIcon from 'assets/images/svg/userCenter/wallet.svg'
import LogoutIcon from 'assets/images/svg/userCenter/logout.svg'
// import CollectIcon from 'assets/images/svg/userCenter/collect.svg'
import RecordsIcon from 'assets/images/svg/userCenter/records.svg'

export type Menu = {
  text: string
  icon: string
  link?: string
}

export const menus: Menu[] = [
  {
    text: 'Profile',
    icon: ProfileIcon,
    link: '/profile',
  },
  {
    text: 'My Wallet',
    icon: WalletIcon,
    link: '/wallet',
  },
  {
    text: 'My Inbox',
    icon: '',
    link: '/inbox',
  },
  {
    text: 'Favorites',
    icon: RecordsIcon,
    link: '/favorite',
  },
  {
    text: 'History',
    icon: RecordsIcon,
    link: '/records',
  },
  {
    text: 'Settings',
    icon: RecordsIcon,
    link: '/setting/account',
  },
  {
    text: 'Log Out',
    icon: LogoutIcon,
  },
]

export const NotificationMenu: Menu[] = [
  {
    text: 'Price notification',
    icon: '',
    link: '/setting/notification/mpa',
  },
]
